import React from 'react'
import { useStaticDataStore } from '../../stores/staticData';
import dummyCompany from '../../assets/images/dummyCompany.png'

const StartupTab = ({ selectedFounder, startupData }) => {
    const { data: staticData } = useStaticDataStore();

    let industryTags = [];
    if (staticData?.industryTags?.length) {
        industryTags = staticData?.industryTags;
    }
    let startupStages = [];
    if (staticData?.startupStages?.length) {
        startupStages = staticData?.startupStages;
    }
    let investmentTerm = [];
    if (staticData?.investmentTerm?.length) {
        investmentTerm = staticData?.investmentTerm;
    }

    return (
        <div className='founder-edit-section'>
            <div className='founder-details'>
                <div className='founder-dummy-image'>
                    <img src={startupData?.logo || dummyCompany} alt="company dummy image" />
                </div>
                <div className='founder-detail-section founder-company-section'>
                    <div>
                        <span className='label'>Full name</span>
                        <div className='value'>{startupData?.name}</div>
                    </div>
                    <div>
                        <span className='label'>Tagline</span>
                        <div className='value'>{startupData?.tegLine}</div>
                    </div>
                    <div>
                        <span className='label'>Industries</span>
                        <div className="value">
                            {startupData?.industryTags?.map((key, idx) => {
                                const matched = industryTags?.find(item => item?.key === key);
                                return (
                                    <span key={key}>
                                        {matched?.value || key}
                                        {idx < startupData?.industryTags?.length - 1 ? ', ' : ''}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                    <div>
                        <span className='label'>Startup stage</span>
                        <div className="value">
                            {startupData?.startupStages?.map((key, idx) => {
                                const matched = startupStages?.find(item => item?.key === key);
                                return (
                                    <span key={key}>
                                        {matched?.value || key}
                                        {idx < startupData?.startupStages?.length - 1 ? ', ' : ''}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                    <div>
                        <span className='label'>LinkedIn page</span>
                        <div className='value'>{startupData?.linkedInUrl}</div>
                    </div>
                    <div>
                        <span className='label'>Website</span>
                        <div className='value'>{startupData?.website}</div>
                    </div>
                    <div>
                        <span className='label'>About the startup</span>
                        <div className='value'>{startupData?.about}</div>
                    </div>
                    <div>
                        <span className='label'>Amount raising</span>
                        <div className='value'>${startupData?.amountRaising || 0}</div>
                    </div>
                    <div>
                        <span className='label'>Investment term</span>
                        <div className="value">
                            {
                                staticData?.investmentTerm?.find(item => item.key === startupData?.investmentTerm)?.value
                                || startupData?.investmentTerm
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StartupTab